import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationItem } from './navigation-item.interface';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLinkActive, RouterLink, SvgIconComponent, TranslateModule],
})
export class NavigationItemComponent {
  @Input() public menuItem: NavigationItem;
}
